// `Model` from its own module, not the `@/models` barrel — see the note in `index.ts`.
import { Model } from './model';
import { type NetworkBlob } from '@/models';
import { DateTime } from 'luxon';

interface IBlob {
    identifier: string;
    name: string;
    contentType: string;
    size: number;
    storedAt: Date;
    hasThumbnail: boolean;
    thumbnailKey?: string;
}

export class BlobModel extends Model {
  identifier: string;
  name: string;
  contentType: string;
  size: number;
  storedAt?: Date;
  hasThumbnail?: boolean;
  thumbnailKey?: string;
  downloadedBlob?: string;

  file?: File;
  progress?: number;
  label?: string;
  isLoading?: boolean;

  originalFile?: File;
  convertedFile?: boolean;

  constructor({
    identifier,
    name,
    contentType,
    size,
    storedAt,
    hasThumbnail
  }: IBlob) {
    super();
    this.identifier = identifier;
    this.name = name;
    this.contentType = contentType;
    this.size = size;
    this.storedAt = storedAt;
    this.hasThumbnail = hasThumbnail;
  }

  static mapFromBackend(networkBlob: NetworkBlob) {
    return new BlobModel({
      identifier: networkBlob.identifier,
      name: networkBlob.name,
      contentType: networkBlob.contentType,
      size: networkBlob.size,
      storedAt: DateTime.fromISO(networkBlob.storedAt).toJSDate(),
      hasThumbnail: networkBlob.hasThumbnail,
      thumbnailKey: networkBlob.thumbnailKey
    });
  }
}
